<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Pathway Visualizer</div>

    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()" style='margin:auto'>
        <div class="form-group">
            <mat-form-field>
                <mat-label>Select Cancer related Pathway</mat-label>

                <mat-select [(value)]="selected_pathway" formControlName="selected_pathway">
                    <mat-option *ngFor="let pathway of kegg_pathways;let i=index" value={{pathway[0]}}>
                        {{pathway[0]}} - {{pathway[1]}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            <!-- <mat-form-field>
                <mat-label>Filter Connections (currently not working)</mat-label>
                <mat-select [(value)]="selected_connections" formControlName="selected_connection">
                    <mat-option> Activations </mat-option>
                    <mat-option> Inhibition </mat-option>
                    <mat-option> Methylation </mat-option>
                    <mat-option> Phosphorylation </mat-option>
                    <mat-option> Dephosphorylation </mat-option>
                    <mat-option> ... </mat-option>
                </mat-select>
            </mat-form-field> -->

            <!-- <mat-form-field>
                <mat-label>Locate Genes (currently not working)</mat-label>
                <mat-select [(value)]="selected_genes" formControlName="selected_genes">
                    <mat-option> TP53 </mat-option>
                    <mat-option> BRAF </mat-option>
                    <mat-option> MDM2 </mat-option>
                    <mat-option> MEK </mat-option>
                    <mat-option> ERK </mat-option>
                    <mat-option> ... </mat-option>
                </mat-select>
            </mat-form-field> -->

            <div>
                <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
            </div>
        </div>
    </form>
</div>


<div style="display: flex;">
    <iframe src="" frameborder="0" allowfullscreen style="height:500px; width:100%;" id="iframeID"></iframe>
    <div><span style="font-weight: bold;">Legend:</span>
        <ul>
            <li><span style="color:red">Red:</span> Activation</li>
            <li><span style="color:blue">Blue:</span> Inhibition</li>
            <li><span style="color:green">Green:</span> Expression</li>
            <li><span style="color:yellow">Yellow:</span> Repression</li>
            <li><span style="color:orange">Orange:</span> Indirect Effect</li>
            <li><span style="color:purple">Purple:</span> State Change</li>
            <li><span style="color:hotpink">Pink:</span> Binding/Association</li>
            <li><span style="color:brown">Brown:</span> Dissociation</li>
            <li><span style="color:black">Black:</span> Missing Interaction</li>
            <li><span style="color:gray">Gray:</span> Phosphorylation</li>
            <li><span style="color:cyan">Cyan:</span> Dephosphorylation</li>
            <li><span style="color:magenta">Magenta:</span> Glycosylation</li>
            <li><span style="color:lime">Lime:</span> Ubiquitination</li>
            <li><span style="color:olive">Olive:</span> Methylation</li>
        </ul>
    </div>
</div>